import type { RootState } from "../store"

export const userDetailsSelector = (state: RootState) => state.userDetails
